import type { ActivitySource } from './schema';

// userId also identifies an owner for integrations; only manual provenance identifies an actor.
export function resolveActivitySource(
  source: ActivitySource | null | undefined,
  content: string
): ActivitySource {
  if (source === 'manual') return source;
  // Older capture Flow receipts were tagged as integrations despite an authenticated submission.
  if (content === 'Lead created through the WhatsApp lead capture Flow.') return 'manual';
  if (source) return source;
  if (
    /^(?:WhatsApp AI|AI automation|Automated |Automatically |System-generated |Cron\b|Background job\b|Scheduled reminder\b|.*reminder sent\b)/i.test(
      content
    )
  ) {
    return 'automation';
  }
  if (
    /^(?:Incoming WhatsApp message:|Created from .+ Gmail lead email\.|Imported from .+ via Gmail\.)/i.test(
      content
    )
  ) {
    return 'integration';
  }
  if (
    /^(?:Pipeline stage changed from|Temperature changed:|Lead (?:closed|reopened):|Product changed:|Follow-up (?:scheduled:|rescheduled:|updated:|removed\.))/i.test(
      content
    )
  ) {
    return 'system';
  }
  return 'manual';
}

export function resolveLeadCreationSource(
  source: string | null | undefined,
  activities: { content: string; source?: ActivitySource | null }[] = []
): ActivitySource {
  const receipt = activities.find(activity =>
    /^(?:Lead created\.|Lead created through the WhatsApp lead capture Flow\.|Created from .+ Gmail lead email\.|Imported from .+ via Gmail\.)/.test(
      activity.content
    )
  );
  if (receipt) return resolveActivitySource(receipt.source, receipt.content);
  return /^(?:whatsapp|gmail|olx|carwale|gaadi|cardekho|facebook|instagram|threads)$/i.test(
    source?.trim() ?? ''
  )
    ? 'integration'
    : 'manual';
}
